// extracted by mini-css-extract-plugin
export default {"moreIcon":"TopCategoryListBar_moreIcon__NAT0i"};